export enum StatusUserEnum {
	Active = 1,
	Suspended = 2,
	Blocked = 3,
}
